import { render, staticRenderFns } from "./PageLoadingIndicator.vue?vue&type=template&id=5746478d&scoped=true"
import script from "./PageLoadingIndicator.vue?vue&type=script&lang=js"
export * from "./PageLoadingIndicator.vue?vue&type=script&lang=js"
import style0 from "./PageLoadingIndicator.vue?vue&type=style&index=0&id=5746478d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5746478d",
  null
  
)

export default component.exports